import { Component, OnInit, Output } from '@angular/core';

import { Router } from '@angular/router';
import { NavigateService } from '../../service/navigate.service';

import { PersonService } from '../../service/person.service';
import { HomeService } from "../../service/home.service";
declare var $: any;

@Component({
    selector: 'app-vote',
    templateUrl: './vote.component.html',
    styleUrls: ['./vote.component.styl']
})

export class VoteComponent implements OnInit {

    modal = {
		title: 'CHINAICAC MEMBER SIGN IN',
		isSigninShow: false,
		closeShow: false,
		isVoteShow: false,
		voteName: '',
		voteId:Number,
		sessionId: Number
	};
	isLogin: boolean;
	isVoted:boolean

	candidatesList=[
	]

    constructor(private router: Router,private personService: PersonService,private navigateService: NavigateService,private HomeService:HomeService) { }

    ngOnInit() {

		this.getElectList()
		window.scrollTo(0, 0)
    }

	getElectList(){
		this.HomeService.getElectVoteDetail().subscribe(res=>{
			console.log(res)
			if (res.ok) {
				this.isVoted = res.data.userVoted
				this.candidatesList = res.data.candidateList
			}
		})
	}

    success(item){
		console.log(item);
		this.isLogin = true;
		this.modal.isVoteShow = true;
		this.modal.voteName = item.candidateName
		this.modal.voteId = item.id
		this.modal.sessionId = item.sessionId
	}
	putVote(item){
		this.personService.getUserInfo().subscribe(res => {
			res.ok ? this.success(item) : this.modal.isSigninShow = true ;
		});
		
	}
	goDetail(item){
		this.router.navigate(['/candidate/vote/vote-detail'],{
			queryParams: { candidateId: item.id },
		})
	}
    onConfirm(){
		console.log('confirm');
		this.modal.isSigninShow = false
	}
	onCancel(){
		this.modal.isVoteShow = false;
		this.getElectList()
	}

}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/vote/index/vote.component.ts